import { MY_PLAN } from '../graphql/queries/UserQueries'
import { mapGetters } from 'vuex'

const myPlanData = {
  apollo: {
    _billingPlan: {
      query: MY_PLAN,
      update: data => {
        return {
          name: 'free',
          ...data.myUser.billingPlan
        }
      },
      result({ data, errors, loading }) {
        if (!loading && !errors) {
          this.$store.dispatch('setUser', data.myUser)
        }
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  computed: {
    ...mapGetters(['plan', 'isSubscribed']),
    expire() {
      console.log(this.$store.getters)
      return this.plan
        ? this.$moment(this.plan.expire).format('DD MMMM YYYY')
        : ''
    }
  }
}

export default myPlanData
